// extracted by mini-css-extract-plugin
export default {"container":"DaysAgoBox_container__6WAwh","yellow":"DaysAgoBox_yellow__9n7SH","red":"DaysAgoBox_red__pgkve"};